export const AUTH_API = process.env.AUTH_API || 'https://auth.jrc.no';
export const AUTH0_CLIENT_ID = 'QVdD8J9hDfohKzAEVe32o3ubYYhkkt3q';
export const AUTH0_AUDIENCE = 'https://butler.jrc.no/api';
export const AUTH0_DOMAIN = 'jrc.eu.auth0.com';
export const AUTH0_LEEWAY = 120; // Acceptible time difference between PC clock and auth0 token start time. The PC clock may be 2 minutes too slow without an error triggering.
